export default __webpack_public_path__ + "static/media/AiJoining.b0416d89.png";